import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiDealsPipelineNotFoundError } from '@/core/error/transport/tmApiDealsPipelineNotFoundError'

export const dealsPipelineNotFoundErrorRule: CustomErrorRule = {
  klass: TmApiDealsPipelineNotFoundError,
  predicateFn: (error) => {
    return error.response.data.message.includes('DealPipeline object not found')
  },
}
